import { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/default/header";
import SidebarMenu from "./menu/sidebarMenu";
import Breadcrumb from "../default/breadcrumb/breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { GetGalleryItems } from "../../store/actions/new/galleryAction";
import NoContentFound from "../default/not-found/notFound";
import { ShimmerSimpleGallery } from "react-shimmer-effects";
import SearchForm from "../default/search/searchForm";
import 'lightbox2/dist/css/lightbox.min.css';
import lightbox from 'lightbox2/dist/js/lightbox';
import ShimmerImage, { ShimmerThumbnailImage } from "../default/popup/shimmerImage/shimmerImage";
const CardGallery = () => {

    const [hasLoaded, setHasLoaded] = useState(false);
    lightbox.option({
        'disableScrolling': true
    })
    const allData = useSelector((state) => state.galleryAllData);
    const { galleryData, error, isLoading } = allData;
    const { data, pagination } = galleryData;
    const [index, setIndex] = useState(-1);
    const [pageCount, setPageCount] = useState(1);
    const [loading, setLoading] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const prevSearchTermRef = useRef();
    const [imageLoading, setImageLoading] = useState({});

    const dispatch = useDispatch();
    useEffect(() => {
        if (!hasLoaded) {
            // Check if store already has data
            if (!galleryData || !galleryData.data || galleryData.data.length === 0) {
                let postData = {
                    page: 1,
                    keyword: ''
                }
                dispatch(GetGalleryItems(postData));
            }
            setHasLoaded(true);
        }
        if (prevSearchTermRef.current !== searchTerm) {
            searchPhoto();
        }
        prevSearchTermRef.current = searchTerm;

    }, [dispatch, data, searchTerm])

    const searchPhoto = async () => {
        if (!hasLoaded) return;
        setLoading(true);
        let postData = {
            page: 1,
            keyword: searchTerm
        }
        await dispatch(GetGalleryItems(postData));
        setLoading(false);
    }

    const loadMore = () => {
        const nextPage = pagination.page + 1;
        if (nextPage <= pagination.page_last) {
            setPageCount(nextPage);
            let postData = {
                page: nextPage,
                keyword: searchTerm
            }
            dispatch(GetGalleryItems(postData));
        }
    };


    return (
        <div className="content-wrapper sidebar-menu-enable">
            <Helmet><title>Gallery - Cardiast</title></Helmet>
            <Header />
            <div className="sidebar-with-content ds-flex">
                <SidebarMenu />
                <div className="content-right gallery-wrapper">
                    <Breadcrumb />
                    <div className="connection-header">
                        <h3>Gallery</h3>
                        <div className="filter-wrapper">
                            <SearchForm
                                placeholder='Search card...'
                                loading={loading}
                                onChange={async (val) => {
                                    setSearchTerm(val);
                                }}
                            />
                        </div>
                    </div>
                    {Array.isArray(data) && data.length > 0 && (
                        <div className="gallery" id="files-gallery">
                            {data.map((image, i) => (
                                <a className="single-gallery-item" data-lightbox="mygallery" href={image.url} key={i}>
                                    <ShimmerThumbnailImage
                                        src={image.url ? image.url : `https://avatar.iran.liara.run/username?username=${image.title}&background=f1f7ff&color=4491F5`}
                                        alt={image.title}
                                        fitOnFrame={true}
                                    />
                                </a>
                            ))}
                        </div>
                    )}
                    <>
                        {!isLoading && !data &&
                            <NoContentFound title="No photo found!" />
                        }
                        {isLoading &&
                            <>
                                <ShimmerSimpleGallery row={2} col={4} imageHeight={140} />
                            </>
                        }
                        {!isLoading && data && pagination.page_last > pagination.page && (
                            <div className="load-more-container">
                                <button
                                    className="load-more-btn"
                                    onClick={loadMore}
                                    disabled={isLoading}
                                >
                                    {isLoading ? 'Loading...' : 'Load More'}
                                </button>
                            </div>
                        )}
                    </>
                </div>
            </div>

        </div>
    );
}

export default CardGallery;
